/**
 * Returns styles shared among several chart components.
 */
export default {
	font: "titilliumtext22lregular, sans-serif",
	fontBold: "titilliumtext22lbold, sans-serif",
	fontSize: "12px",
	dataLabelFontSize: "14px",
	axisFontSize: "12px",
	backgroundColor: "#EDEDED",
	highlightColor: "#ffedab",
	hoverColor: "#E0E0E0",
	axisLabelColor: "#808080",
	chartBackgroundColor: "#FFFFFF",
	dataLabelColor: "#997800",
};
